import * as React from 'react';
import { ComponentProvider } from '../component-provider';
import { ThemeProvider } from '../theme-provider';
import { I18nProvider, I18nProviderProps } from '../i18n-provider';
import { GridProvider } from '../grid';

type RefereeProviderProps = React.ComponentProps<typeof ComponentProvider> &
    React.ComponentProps<typeof ThemeProvider> & { locale?: I18nProviderProps['locale'] };

export const RefereeProvider: React.FunctionComponent<RefereeProviderProps> = (props) => {
    const { children, components, theme, testId, locale = 'en-US', ...passThroughProps } = props;

    return (
        <ThemeProvider {...passThroughProps} theme={theme} testId={testId}>
            <I18nProvider locale={locale}>
                <ComponentProvider components={components}>
                    <GridProvider>{children}</GridProvider>
                </ComponentProvider>
            </I18nProvider>
        </ThemeProvider>
    );
};
